import { TASK_SHOW } from '../../config/activity';
import { elk, CustomException } from '@tencent/ppd-base-libs';
import { chunk } from 'lodash-es';
export const reportTaskShowRes = (res, params) => {
    try {
        const cgiName = TASK_SHOW.split('/').reverse()[0];
        // 正常返回的情况
        if ((res === null || res === void 0 ? void 0 : res.retcode) === '0') {
            const { actTaskInfoList = [] } = res || {};
            const groupRes = chunk(actTaskInfoList, 3); // 分组
            const groupId = String(Math.random()).split('.')[1];
            groupRes.forEach((groupItem) => {
                elk({
                    key: cgiName,
                    msg: JSON.stringify(groupItem),
                    str1: groupId,
                    errCode: res.retcode,
                    str4: JSON.stringify(params),
                    str2: 'ajax',
                });
            });
            return;
        }
        // 异常情况
        elk({
            key: cgiName,
            msg: JSON.stringify(res),
            errCode: res === null || res === void 0 ? void 0 : res.retcode,
            str4: JSON.stringify(params),
            str2: 'ajax',
        });
        new CustomException(JSON.stringify(Object.assign({ cgi: cgiName }, res)), 'qryTaskShowResFail', '查询任务接口失败');
        return;
    }
    catch (e) {
        new CustomException(e, 'reportExchActPrizeInfoResFail', '自定义上报查询任务接口失败');
    }
};
